import { pad2 } from './string';

const { contrastColor } = require('contrast-color');


/**
 * Determines which color ('#fff' || '#000') contrasts better.
 * @param {string} color
 * @returns contrast color #fff or #000
 */
export function contrast(color) {
    if (!color) return '#000';
    const whichFG = contrastColor({ bgColor: color });
    return whichFG;
}

/**
 * Converts a hexadecimal color into a hexadecimal with it's alpha
 * @param {string | undefined} color
 * @param {number} opacity
 * @returns a hexadecimal color with the alpha (opacity)
 */

export function colorOpacity(color, opacity) {
    if (!color) return undefined;
    return color + pad2(Math.floor(opacity / 100 * 255 || 0 * 255).toString(16));
}

/**
 * Converts two colors into a classname that can be used as a linear gradient
 * @param {string | undefined} topColor
 * @param {string | undefined} bottomColor
 * @returns a linear gradient classname
 */

export function linearGradient(topColor, bottomColor) {
    if (!topColor || !bottomColor) return null;
    return `linear-gradient(${topColor}, ${bottomColor})`;
}